export default __webpack_public_path__ + "static/media/2025.d822c1ca.png";